<template>
  <div class="animated fadeIn">
    <Alerts ref="alert"/>
    <Forms ref="frmGroup"
      :title="this.$lang.Insured.TitleForm"
      :showHelp="true"
      :showClearButton="true"
      :showSaveButton="true"
      v-on:Clear="onClear"
      v-on:Save="onSave">
      <div class="form-group row">
        <div class="col-md-6">
          <label for="txtInsuredName"><small class="text-danger">*</small> {{$lang.Insured.Name}}:</label>
          <div class="input-group">
            <b-form-input type="text"
                          name="txtInsuredName"
                          :placeholder="$lang.Insured.PlaceholderEnterName"
                          v-model="form.name.value"
                          :maxlength="form.name.maxlength"
                          :required="form.name.required"
                          :state="form.name.state"></b-form-input>
          </div>
        </div>
        <div class="col-md-6">
          <label for="txtCPFCNPJ"><small v-show="form.cpfCnpj.required" class="text-danger">*</small>  {{$lang.Insured.CPF_CNPJ}}:</label>
          <div class="input-group">
            <b-form-input type="text"
                          name="txtCPFCNPJ"
                          :placeholder="$lang.Insured.PlaceholderEnterCPFCNPJ"
                          v-model="form.cpfCnpj.value"
                          :size="form.cpfCnpj.maxlength"
                          :required="form.cpfCnpj.required"
                          :state="form.cpfCnpj.state"
                          v-mask="['###.###.###-##','##.###.###/####-##','###.###.###/####-##']"/>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-6">
          <label for="txtRG"><small v-show="form.rg.required" class="text-danger">*</small>  {{$lang.Insured.RG}}:</label>
          <div class="input-group">
            <b-form-input type="text"
                          name="txtRG"
                          :placeholder="$lang.Insured.PlaceholderEnterRG"
                          v-model="form.rg.value"
                          :size="form.rg.maxlength"
                          :required="form.rg.required"
                          :state="form.rg.state"/>
          </div>
        </div>
        <div class="col-md-6">
          <label for="txtCNH"><small v-show="form.cnh.required" class="text-danger">*</small>  {{$lang.Insured.CNH}}:</label>
          <div class="input-group">
            <b-form-input type="text"
                          name="txtCNH"
                          :placeholder="$lang.Insured.PlaceholderEnterCNH"
                          v-model="form.cnh.value"
                          :size="form.cnh.maxlength"
                          :required="form.cnh.required"
                          :state="form.cnh.state"/>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-8">
          <label for="txtAddress"><small v-show="form.address.required" class="text-danger">*</small>  {{$lang.Insured.Address}}:</label>
          <div class="input-group">
            <b-form-input type="text"
                          name="txtAddress"
                          :placeholder="$lang.Insured.PlaceholderEnterAddress"
                          v-model="form.address.value"
                          :size="form.address.maxlength"
                          :required="form.address.required"
                          :state="form.address.state" />
          </div>
        </div>
        <div class="col-md-4">
          <label for="txtAddressNumber"><small v-show="form.addressNumber.required" class="text-danger">*</small>  {{$lang.Insured.AddressNumber}}:</label>
          <div class="input-group">
            <b-form-input type="text"
                          name="txtAddressNumber"
                          :placeholder="$lang.Insured.PlaceholderEnterAddressNumber"
                          v-model="form.addressNumber.value"
                          :size="form.addressNumber.maxlength"
                          :required="form.addressNumber.required"
                          :state="form.addressNumber.state" />
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-4">
          <label for="txtDistrict"><small v-show="form.district.required" class="text-danger">*</small>  {{$lang.Insured.District}}:</label>
          <div class="input-group">
            <b-form-input type="text"
                          name="txtDistrict"
                          :placeholder="$lang.Insured.PlaceholderEnterDistrict"
                          v-model="form.district.value"
                          :size="form.district.maxlength"
                          :required="form.district.required"
                          :state="form.district.state" />
          </div>
        </div>
        <div class="col-md-4">
          <label for="txtAddressInsured"><small v-show="form.complement.required" class="text-danger">*</small>  {{$lang.Insured.Complement}}:</label>
          <div class="input-group">
            <b-form-input type="text"
                          name="txtAddressInsured"
                          :placeholder="$lang.Insured.PlaceholderEnterComplement"
                          v-model="form.complement.value"
                          :size="form.complement.maxlength"
                          :required="form.complement.required"
                          :state="form.complement.state" />
          </div>
        </div>
        <div class="col-md-4">
          <label for="txtAddressInsured"><small v-show="form.zipcode.required" class="text-danger">*</small>  {{$lang.Insured.Zipcode}}:</label>
          <div class="input-group">
            <b-form-input type="text"
                          name="txtAddressInsured"
                          :placeholder="$lang.Common.ZipcodePlaceholder"
                          v-model="form.zipcode.value"
                          :size="form.zipcode.maxlength"
                          :required="form.zipcode.required"
                          :state="form.zipcode.state"
                          v-mask="['#####-###']" />
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-4">
          <label for="cbxCountry"> {{$lang.Insured.LabelCoutry}}:</label>
          <div class="input-group">
            <select class="mb-3 form-control custom-select" disabled>
              <option value="2375E209-7451-4A7A-A9BE-66BD2C392BE1" selected>BRASIL</option>
            </select>
          </div>
        </div>
        <div class="col-md-4">
          <label for="cbxState"><small v-show="form.stateID.required" class="text-danger">*</small> {{$lang.Insured.LabelState}}:</label>
          <div class="input-group">
            <b-form-select v-model="form.stateID.value"
                          :options="form.stateID.options"
                          :state="form.stateID.state"
                          class="mb-3"
                          name="cbxState"
                          @change="onChangeState">
              <template slot="first">
                <option :value="null" disabled>{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-4">
          <label for="cbxCity"><small v-show="form.cityID.required" class="text-danger">*</small> {{$lang.Insured.LabelCity}}:</label>
          <div class="input-group">
            <b-form-select v-model="form.cityID.value"
                          :options="form.cityID.options"
                          :state="form.cityID.state"
                          class="mb-3"
                          name="cbxCity">
              <template slot="first">
                <option :value="null" disabled>{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
      </div>
      <div class="form-group row">
            <div class="col-md-4">
              <label for="txtPhone"><small v-show="form.phoneNumber.required" class="text-danger">*</small>  {{$lang.Sinister.Details.Phone}}:</label>
              <div class="input-group">
                <span class="input-group-addon"><i class="fa fa-phone"></i></span>
                <b-form-input type="text"
                              name="txtPhone"
                              :placeholder="$lang.Common.PhonePlaceholder"
                              v-model="form.phoneNumber.value"
                              :size="form.phoneNumber.maxlength"
                              :required="form.phoneNumber.required"
                              :state="form.phoneNumber.state"
                              v-mask="['(##) ####-####']"  />
              </div>
            </div>
            <div class="col-md-4">
              <label for="txtCellPhone"><small v-show="form.cellNumber.required" class="text-danger">*</small>  {{$lang.Sinister.Details.CellPhone}}:</label>
              <div class="input-group">
                <span class="input-group-addon"><i class="fa fa-mobile-phone"></i></span>
                <b-form-input type="text"
                              name="txtCellPhone"
                              :placeholder="$lang.Common.MobilePhonePlaceholder"
                              v-model="form.cellNumber.value"
                              :size="form.cellNumber.maxlength"
                              :required="form.cellNumber.required"
                              :state="form.cellNumber.state"
                              v-mask="['(##) ####-####', '(##) # ####-####']"  />
              </div>
            </div>
            <div class="col-md-4">
              <label for="txtEmail">{{$lang.Sinister.Details.EmailMachineWorkshop}}:</label>
              <div class="input-group">
                <span class="input-group-addon"><i class="fa fa-envelope"></i></span>
                <b-form-input type="text"
                              name="txtEmail"
                              :placeholder="$lang.Sinister.Details.PlaceholderEmail"
                              v-model="form.email.value"
                              :size="form.email.maxlength"
                              :required="form.email.required"
                              :state="form.email.state"/>
              </div>
            </div>
          </div>
    </Forms>
    <Tables ref="tableGrid"
        :columns="[$lang.Insured.DataTable.Name,
                    $lang.Insured.DataTable.CPF_CNPJ,
                    $lang.Common.DataTable.Status,
                    $lang.Common.DataTable.ActionDate,
                    $lang.Common.DataTable.AccountAction,
                    $lang.Common.DataTable.Actions]"
        :showSearch="false"
        :showPrint="true"
        :showDownload="false"
        :showFullscreen="false"
        v-on:Load="onLoad">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.name" />
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.mnemonic" />
        <TableColumn :IsStatus="true" v-on:Edit="onEdit(obj)" :status="obj.status" />
        <TableColumn :IsDatetime="true" v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.dateUpdate" />
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.accountUserNameUpdate" />
        <TableColumn :IsActionsButtons="true" v-on:Change="onChange(obj)" v-on:Delete="onDelete(obj)" :status="obj.status" />
      </tr>
    </Tables>
  </div>
</template>

<script>
import Insured from './insured.js'

export default Insured
</script>



// WEBPACK FOOTER //
// src/views/private/configuration/insured/insured.vue